import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useMutation } from "react-query";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import PopupModel from "../popupmodel/PopupModel";
const NewCustomer = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: "Active",
      customerLevel: "Others",
    },
    mode: "onSubmit",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/customersadd`,
          postData
        );

        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add customer",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        if (error?.status == 409) {
          alert(error?.response?.data);
        } else {
          alert("Failed to add Customers. Please try again.");
        }
      },
    }
  );
  //

  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/customersadd/${state?.id}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error updating quotation:", error);
        throw error; // re-throw to trigger onError
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add customer",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to update the Customers. Please try again.");
      },
    }
  );

  // SETVALUE

  useEffect(() => {
    setValue("customerName", state?.customerName);
    setValue("ownerName", state?.ownerName);
    setValue("companyName", state?.companyName);
    setValue("customerAddress", state?.customerAddress);
    setValue("contact", state?.contact);
    setValue("pincode", state?.pincode);
    setValue("gstNumber", state?.gstNumber);

    setValue("lineRoute", state?.lineRoute);
    setValue("status", "Active" || state?.status);
    setValue("routeName", state?.routeName);
    setValue("state", state?.state);

    if (state?.customerLevel) {
      setValue("customerLevel", state?.customerLevel);
    }
  }, [state, setValue]);

  // FORM SUBMIT
  const onSubmit = (data) => {
    let formData = {
      customerName: data?.customerName,
      ownerName: data?.ownerName,
      companyName: data?.companyName,
      customerAddress: data?.customerAddress,
      contact: data?.contact,
      gstNumber: data?.gstNumber,
      customerLevel: data?.customerLevel,
      lineRoute: data?.lineRoute,
      status: data?.status,
      pincode: data?.pincode,
      routeName: data?.routeName,
      state: data?.state || null,
    };
    if (state?.id) {
      updateApi(formData);
    } else {
      mutate(formData);
    }
  };

  return (
    <>
      <div className="form_main_block">
        <div className="form_sub_block">
          <form className="p-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="row px-3 d-flex gap-3 my-2">
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">
                  Customer Name<span style={{ color: "red" }}>*</span>
                </label>

                <Controller
                  name="customerName"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Customer name is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <input
                        {...field}
                        type="text"
                        placeholder="Customer Name"
                        className={`product_input_field ${
                          error ? "text-danger" : ""
                        }`}
                      />
                      {error && (
                        <p
                          className="text-danger text-sm mt-1"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          {error?.message}
                        </p>
                      )}
                    </>
                  )}
                />
              </div>

              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">Company Name</label>
                <Controller
                  name="companyName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Company Name"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">
                  Customer Address<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="customerAddress"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Customer address is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <input
                        {...field}
                        type="text"
                        placeholder="Customer Address"
                        className="product_input_field"
                      />
                      {error && (
                        <p className="text-danger" style={{ fontSize: "12px" }}>
                          {error?.message}
                        </p>
                      )}
                    </>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">
                  State<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="state"
                  control={control}
                  defaultValue=""
                  rules={{ required: "State is required" }} // ✅ Validation rule
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <input
                        {...field}
                        type="text"
                        placeholder="Tamil Nadu"
                        className="product_input_field"
                      />
                      {error && (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          {error.message}
                        </p> // ✅ Error message
                      )}
                    </>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">Pincode</label>
                <Controller
                  name="pincode"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="636212"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">
                  Contact<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="contact"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Contact number is required" }}
                  render={({ field, fieldState: { error, invalid } }) => (
                    <div className="mb-3">
                      <input
                        {...field}
                        type="tel"
                        placeholder="8010389345"
                        aria-invalid={invalid}
                        className={`product_input_field ${
                          invalid ? "is-invalid" : ""
                        }`}
                      />
                      {error && (
                        <div
                          className="invalid-feedback"
                          style={{ fontSize: "12px" }}
                        >
                          {error?.message}
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">GST Number</label>
                <Controller
                  name="gstNumber"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="8010389345"
                      className="product_input_field"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">
                  Customer Level<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="customerLevel"
                  control={control}
                  rules={{ required: "Customer Level is required" }}
                  render={({ field }) => (
                    <select
                      {...field}
                      className={`product_input_field ${
                        errors.customerLevel ? "is-invalid" : ""
                      }`}
                    >
                      {/* Keep placeholder disabled */}
                      <option value="Others">Others</option>
                      <option value="High Level">High Level</option>
                      <option value="Mid Level">Mid Level</option>
                      <option value="Low Level">Low Level</option>
                    </select>
                  )}
                />

                {errors.customerLevel && (
                  <div
                    className="invalid-feedback"
                    style={{ fontSize: "12px" }}
                  >
                    {errors.customerLevel.message}
                  </div>
                )}
              </div>

              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">Line Route</label>

                <Controller
                  name="lineRoute"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      {...field}
                      className="product_input_field"
                      placeholder="Enter Route"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">Route Name</label>
                <Controller
                  name="routeName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      className="product_input_field"
                      placeholder="Enter Route Name"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-2 p-0">
                <label className="executive_label">Status</label>
                <Controller
                  name="status"
                  control={control}
                  render={({ field }) => (
                    <select {...field} className="product_input_field">
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  )}
                />
              </div>
            </div>
            {/* 
            <div className="row px-3 d-flex gap-3 my-2">
            </div> */}

            <div className="row px-3 my-4">
              <div className="col-12 col-md-2 p-0">
                <button className="product_form_submit_btn" type="submit">
                  {postLoading || putLoading ? (
                    <>
                      <i class="fa fa-spinner fa-spin"></i>
                    </>
                  ) : (
                    <>Submit</>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <PopupModel
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        message="Customer Added Successfully!"
        updatemessage="Customer Updated Successfully!"
        state={state?.id}
        navigateUrl="/viewCustomer"
      />
    </>
  );
};

export default NewCustomer;
